// routes.js — the application route table for the AI-partner product. The single
// source of truth the router consumes (createRouter({ routes: ROUTES, ... })).
// Each entry:
//   path  — pattern with :params (router compiles to regex; params arrive as
//           attributes on the mounted element, declared in each page's static props)
//   name  — stable identifier (state.route.value.name) for active-nav, analytics
//   tag   — custom element the route mounts (registered as a side-effect of load())
//   auth  — DEMO MODE: every request runs as the shared guest, so nothing is
//           auth-gated. (Left as a column for when real auth is restored.)
//   load  — lazy import() so each page is its own code-split chunk.
//
// Order matters — first match wins; literal paths before parametric siblings.
//
// Chat reuses the keystone unified chat page (app/pages/avatar-chat.js). A
// partner is a `doppelganger` owned by the guest, so `/chat/:id` mounts the page
// in OWNED mode (id prop ⇒ full row incl. persona) — the romantic chat surface.

export const ROUTES = [
  { path: '/',          name: 'landing', tag: 'pg-page-landing',          auth: false, load: () => import('./pages/landing.js') },
  { path: '/browse',    name: 'browse',  tag: 'pg-page-partner-gallery',  auth: false, load: () => import('./pages/partner-gallery.js') },
  { path: '/create',    name: 'create',  tag: 'pg-page-partner-builder',  auth: false, load: () => import('./pages/partner-builder.js') },
  { path: '/login',     name: 'login',   tag: 'pg-page-login',            auth: false, load: () => import('./pages/login.js') },
  { path: '/account',   name: 'account', tag: 'pg-page-account',          auth: true,  load: () => import('./pages/account.js') },
  { path: '/admin',     name: 'admin',   tag: 'pg-page-admin',            auth: true,  load: () => import('./pages/admin.js') },
  { path: '/chat/:id',  name: 'chat',    tag: 'pg-page-avatar-chat',      auth: false, load: () => import('./pages/avatar-chat.js') },
];
